<template>
    <div class="devices-list__block scenario-group" v-if="scenarioData" :class="!showLocation ? 'scenario-group__low' : ''">
        <v-expansion-panels>
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <template v-slot:actions>
                        <v-icon class="icon-expand">$expand</v-icon>
                    </template>
                    <div class="group-header">
                        <v-flex xs12 d-flex align-center v-if="scenarioData.location && showLocation">
                            <div class="note-row ma-0 pb-1">
                                {{scenarioData.location}}
                            </div>
                        </v-flex>
                        <div class="group-header__content">
                            <v-layout row class="devices-list__block__title">
                                <v-flex class="title-block">
                                    <div class="title-block__name">
                                        {{ scenarioData.name }}
                                    </div>
                                </v-flex>
                                <v-flex class="btn-block" v-if="!group">
                                    <div class="play-button" v-if="scenarioData.scenario_type === 2">
                                        <div
                                            v-html="require('!html-loader!@/assets/icons/play.svg')"
                                            class="play-button__border"
                                            @click.stop.prevent="startScenario"
                                        />
                                    </div>
                                    <div class="d-inline-flex" v-else>
                                        <v-switch
                                            v-model="scenarioData.enabled"
                                            inset
                                            dense
                                            hide-details
                                            class="pa-0"
                                            :loading="loading"
                                            @click.stop.prevent="changeScenarioState"
                                            color="#FF8484"
                                        ></v-switch>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </div>
                        <v-layout
                            row
                            class="devices-list__block__title mt-2"
                            v-if="scenarioData.scenario_type === 1 && scenarioData.weekdays"
                        >
                            <v-flex class="weekdays-row d-inline-flex">
                                <div
                                    v-for="(day, index) in weekdays"
                                    :key="index"
                                    class="weekday"
                                    :class="{'weekday__active': scenarioData.weekdays.includes(index)}"
                                >
                                    {{ day }}
                                </div>
                            </v-flex>
                            <div class="time-start" v-if="scenarioData.time_start">
                                {{ scenarioData.time_start }}
                            </div>
                        </v-layout>
                        <v-layout column class="devices-list__block__title mt-2" v-if="scenarioData.scenario_type === 4">
                            <v-flex xs12>
                                <v-flex class="d-inline-flex">
                                    <div
                                        v-for="(day, index) in weekdays"
                                        :key="index"
                                        class="weekday"
                                        :class="{'weekday__active': scenarioData.weekdays.includes(index)}"
                                    >
                                        {{ day }}
                                    </div>
                                </v-flex>
                                <div class="time-start" v-if="scenarioData.time_start">
                                    {{ scenarioData.time_start }}
                                </div>
                            </v-flex>
                            <v-flex xs12 mt-2 v-if="scenarioData.launch_period">
                                <div>
                                    Период запуска <span class="time-start"> {{ scenarioData.launch_period | formatMinute }} </span> минут
                                </div>
                            </v-flex>
                            <v-flex xs12 mt-1 v-if="scenarioData.time_interval_for_launching">
                                <div class="subtitle-text">
                                    Интервал работы сценария с
                                    <span class="time-start">
                                        {{ scenarioData.time_interval_for_launching.start | formatTime }}
                                    </span>
                                    до
                                    <span class="time-start">
                                        {{ scenarioData.time_interval_for_launching.end | formatTime }}
                                    </span>
                                </div>
                            </v-flex>
                        </v-layout>
                    </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <div v-if="scenarioData.launch_condition && scenarioData.launch_condition.length > 0" class="mb-3">
                        <div class="bold-text d-block">
                            Условие:
                        </div>
                        <span v-for="(condition, index) in scenarioData.launch_condition" :key="'condition' + index">
                            <span v-if="condition.operator && condition.operator == 'and'" class="d-block">И</span>
                            <span v-else-if="condition.operator && condition.operator == 'or'" class="d-block">ИЛИ</span>
                            <span v-else-if="condition.operator" class="d-inline-flex">{{condition.operator}}</span>
                            <span v-if="condition.device" class="d-inline-flex">
                                <span class="d-inline-flex">{{condition.device.name}}</span>
                                <span v-if="condition.field != 'value'" class="d-inline-flex mx-1">
                                    -> {{fieldTypes[condition.field] || condition.field}}
                                </span>
                                <span class="d-inline-flex mx-1">{{condition.comparison_operator}}</span>
                                <span class="d-inline-flex" v-if="condition.value === true">вкл</span>
                                <span class="d-inline-flex" v-else-if="condition.value === false">выкл</span>
                                <span class="d-inline-flex" v-else>{{condition.value}}</span>
                            </span>
                        </span>
                    </div>

                    <div v-for="(action, index) in actions" :key="'action' + index">
                        <v-divider v-if="actions.length > 0" class="my-1"></v-divider>
                        <v-flex xs12 d-flex align-center v-if="action">
                            <v-flex class="d-inline-flex small-text mr-2" style="width: 18px; max-width: 18px;">
                                {{index + 1}}
                            </v-flex>
                            <v-flex class="scenario-action">
                                <div class="d-inline-flex flex-wrap" v-if="action.type == 1 && action.device">
                                    {{action.device.name}}
                                    <span v-if="!action.device.location" class="d-inline-flex mx-1">
                                        -
                                    </span>
                                </div>
                                <div class="d-inline-flex mx-1" v-if="action.type == 1 && action.device && action.device.location">
                                    ({{ action.device.location }}) -
                                </div>
                                <div class="d-inline-flex flex-wrap" v-if="action.type == 2 && action.scenario">
                                    {{action.scenario.name}}
                                    <span v-if="!action.scenario.location" class="d-inline-flex mx-1">
                                        -
                                    </span>
                                </div>
                                <div class="d-inline-flex mx-1" v-if="action.type == 2 && action.scenario && action.scenario.location">
                                    ({{ action.scenario.location }}) -
                                </div>
                                <div class="d-inline-flex" v-if="action.type == 3 && action.group">
                                    {{action.group.name}} -
                                </div>
                                <div v-if="action.variable" class="d-inline-flex ml-1">{{action.variable.name}}</div>
                                <div v-if="action.state" class="d-inline-flex ml-1">{{action.state.name}}</div>
                                <div
                                    v-else-if="
                                        action.device && action.device.device_type == 12 &&
                                         action.variable && action.variable.value_type == 'select'
                                    "
                                    class="d-inline-flex ml-1"
                                >
                                    Выкл
                                </div>
                                <div v-if="action.number != null" class="d-inline-flex ml-1">{{action.number}}</div>
                                <div v-if="action.type == 4" class="d-inline-flex">
                                    Задержка - {{ formattedSleep(action.sleep) }}
                                </div>
                            </v-flex>
                        </v-flex>
                    </div>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>
import { eventBus } from '../../main.js';
import {getWord} from "@/utils";

export default {
    name: "ScenarioSwitch",
    props: {
        scenario: {
            type: Object,
            required: true,
        },
        group: {
            type: Boolean,
            default: false,
        },
        showLocation: {
            type: Boolean,
            default: false,
        },
        available: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            scenarioData: {},
            loading: false,
            weekdays: ["ПН", "ВТ", "СР", "ЧТ", "ПТ", "СБ", "ВС"],
            fieldTypes: {
                humidity: "Влажность",
                temperature: "Температура",
            },
            actions: [],
        };
    },
    created() {
        this.scenarioData = this.scenario;
        eventBus.$on("scenario", this.setChange);
    },
    beforeDestroy() {
        eventBus.$off("scenario", this.setChange);
    },
    mounted() {
        this.setActions();
    },
    filters: {
        formatMinute(val) {
            let minutes = val / 60;
            minutes = parseInt(minutes) < 10 ? String(minutes).padStart(2, "0") : String(minutes);
            let seconds = val % 60;
            seconds = parseInt(seconds) < 10 ? String(seconds).padStart(2, "0") : String(seconds);
            return minutes + ":" + seconds;
        },
        formatTime(val) {
            let hour = parseInt(val.hour) < 10 ? String(val.hour).padStart(2, "0") : String(val.hour);
            let minute = parseInt(val.minute) < 10 ? String(val.minute).padStart(2, "0") : String(val.minute);
            return hour + ":" + minute;
        },
    },
    methods: {
        setActions() {
            this.actions = [];
            this.scenarioData.actions.forEach((el) => {
                let action = {};
                if (el.device) {
                    action.device = el.device;
                    action.type = 1;
                    let device_type = action.device ? action.device.device_type : "";
                    let availArr = this.available.actions[`device_${device_type}`];
                    if (availArr) {
                        action.variable = availArr.find((avail) => {
                            if (el.state) {
                                return _.has(el.state, avail.key);
                            }
                            return null;
                        });
                        let value_type = action.variable ? action.variable.value_type : null;
                        if (value_type == "select") {
                            action.state = action.variable.values.find((action_value) => {
                                return action_value.value == el.state[action.variable.key];
                            });
                        }
                        if (value_type == "int") {
                            action.number = el.state.value;
                        }
                    }
                }
                if (el.scenario) {
                    action.scenario = el.scenario;
                    action.type = 2;
                    let availArr = this.available.actions.scenario;
                    if (availArr) {
                        action.variable = availArr.find((avail) => {
                            if (el.state) {
                                return _.has(el.state, avail.key);
                            }
                            return null;
                        });
                        let value_type = action.variable ? action.variable.value_type : null;
                        if (value_type == "select") {
                            action.state = action.variable.values.find((action_value) => {
                                return action_value.value == el.state[action.variable.key];
                            });
                        }
                        if (value_type == "int") {
                            action.number = el.state.value;
                        }
                    }
                }
                if (el.scenario_group) {
                    action.group = el.scenario_group;
                    action.type = 3;
                    let availArr = this.available.actions.scenario_group;
                    if (availArr) {
                        action.variable = availArr.find((avail) => {
                            if (el.state) {
                                return _.has(el.state, avail.key);
                            }
                            return null;
                        });
                        let value_type = action.variable ? action.variable.value_type : null;
                        if (value_type == "select") {
                            action.state = action.variable.values.find((action_value) => {
                                return action_value.value == el.state[action.variable.key];
                            });
                        }
                        if (value_type == "int") {
                            action.number = el.state.value;
                        }
                    }
                }
                if (el.sleep) {
                    action.sleep = el.sleep;
                    action.type = 4;
                }
                this.actions.push(action);
            });
            this.actions = _.orderBy(this.actions, ["index"]);
        },
        changeScenarioState() {
            this.loading = true;
            this.$http.patch('/scenarios/home/scenarios/' + this.scenarioData.uid + '/', {
                enabled: this.scenarioData.enabled
            })
                .catch((error) => {
                    console.log(error);
                    this.loading = false;
                });
        },
        setChange(data) {
            if (data.id == this.scenarioData.uid) {
                this.scenarioData.enabled = data.enabled;
                this.loading = false;
            }
        },
        startScenario() {
            this.$http.put('/scenarios/home/scenario/' + this.scenarioData.uid + '/start')
                .catch((error) => {
                    console.log(error);
                });
        },
        formattedSleep(val) {
            if (val > 60) {
                let minutes = Math.floor(val / 60);
                let seconds = val % 60;
                seconds = parseInt(seconds) != 0 ? parseInt(seconds) < 10 ? String(seconds).padStart(2, "0") : String(seconds) : null;
                if (seconds) {
                    return String(minutes) + " " + getWord(minutes, ["минута", "минуты", "минут"]) + " " + seconds + " сек";
                }
                return String(minutes) + " " + getWord(minutes, ["минута", "минуты", "минут"]);
            }
            return val + "  сек";
        },
    },
}
</script>

<style lang="scss">
.time-start {
    font-family: 'Digital';
    font-style: normal;
    font-weight: 400;
    font-size: 22px;
    line-height: 24px;
    color: var(--dark-white);
    display: inline-flex;
}
</style>

<style lang="scss" scoped>
.play-button {
    margin-right: 9px;

    &__border {
        width: 34px;
        box-shadow: 0px 2px 5px rgb(0 0 0 / 15%), 0px 2px 1px rgb(0 0 0 / 6%);
        border-radius: 20px;

        &:hover {
            cursor: pointer;
        }
    }
}

.edit-btn {
    max-width: 28px;
    display: inline-flex;
    align-items: center;

    &:hover {
        cursor: pointer;
    }

    svg {
        max-height: 16px;
    }
}

.subtitle-text {
    font-size: 14px;

    .time-start {
        font-size: 18px;
        line-height: 20px;
    }
}

.scenario-action {
    flex-wrap: wrap;
    display: inline-flex;
    max-width: calc(100% - 20px);
    color: var(--dark-white);
}
</style>